import cx from 'classnames';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import * as React from 'react';
import { mapValues } from 'lodash';

/**
 * ## [Link](/internal/components/Link) that sends an email.
 *
 *
 * ```example
 * <MailTo to="name@school.edu" />
 * ```
 *
 * ```example
 * <MailTo
 *   to="name@school.edu"
 *   cc="name1@school.edu"
 *   bcc="name2@school.edu"
 *   subject="Email subject"
 *   body="Email body">
 *   Send email
 * </MailTo>
 * ```
 */

type DefaultProps = {
  to: string;
  cc: string;
  bcc: string;
  subject: string;
  body: string;
};

type Props = {
  className?: string;
} & DefaultProps;

class MailTo extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    to: '',
    cc: '',
    bcc: '',
    subject: '',
    body: '',
  };

  getOtherMailProps = () => {
    let args = [];
    const { subject, body, cc, bcc } = this.props;
    const encodedProps = mapValues({ subject, body, cc, bcc }, val => encodeURIComponent(val));

    for (const prop in encodedProps) {
      if (encodedProps[prop]) {
        args.push(`${prop}=${encodedProps[prop]}`);
      }
    }

    return args.join('&');
  };

  getMailToLink = () => {
    return `mailto:${this.getTo()}?${this.getOtherMailProps()}`;
  };

  getTo = () => {
    return this.props.to || '';
  };

  renderBody = () => {
    let body;

    if (this.props.children) {
      body = this.props.children;
    } else {
      body = this.getTo();
    }

    return body;
  };

  render() {
    const { className, to, ...other } = this.props; // eslint-disable-line no-unused-vars

    const mailto = (
      <Link
        {...other}
        href={this.getMailToLink()}
        target="_blank"
        className={cx('MailTo', className)}>
        {this.renderBody()}
      </Link>
    );

    return mailto;
  }
}

export default MailTo;
